import React from 'react'

const Info = () => {
  return (
    <svg width='22' height='24' viewBox='0 0 22 24' fill='none' xmlns='http://www.w3.org/2000/svg'>
      <path
        d='M10.5318 0H11.8276V23.9999H10.5318V20.8762L8.64848 21.899L7.50869 19.7348L10.5318 18.1652V15.4725L6.05017 17.3488L5.80811 20.8316L3.46798 20.6293L3.67063 18.3595L0.887577 19.5006L0.0046744 17.2537L2.79893 16.1122L1.12351 14.6051L2.70369 12.789L5.16261 15.1015L10.5319 12.8624V11.9457L5.16261 9.70683L2.6321 12.0189L1.08935 10.2026L2.78306 8.69616L0 7.55484L0.891234 5.30749L3.68604 6.44861L3.50147 4.17884L5.87848 3.97611L6.04949 7.45935L10.5317 9.33563V5.77328L7.57923 4.20405L8.57695 2.03949L10.5317 3.06255L10.5318 0ZM12.8641 2.67286V3.22807C17.529 3.22807 21.4544 7.14934 21.4544 11.9695C21.4544 16.7897 17.5292 20.7114 12.8641 20.7114V21.2662C17.529 21.2662 22 17.0956 22 11.9695C22 6.84341 17.5293 2.67333 12.8641 2.67333V2.67286ZM13.9007 6.32974V13.1869H13.96L13.9574 13.1291L17.5323 15.7583L17.8125 15.2949L14.4192 12.7858V6.32949L13.9007 6.32974ZM12.0866 24H12.3458V9.41394e-05H12.0866V24Z'
        fill='black'
      />
    </svg>
  )
}

export default Info
